import { render, staticRenderFns } from "./SystemAdmin.vue?vue&type=template&id=065cf546&scoped=true&"
import script from "./SystemAdmin.vue?vue&type=script&lang=js&"
export * from "./SystemAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SystemAdmin.vue?vue&type=style&index=0&id=065cf546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065cf546",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VLayout,VRow,VSpacer,VTextField})
